<template>
    <rkm-table
        :fields="fields.table"
        :items="items"
        hide-filters
        hide-pagination
    >

        <template v-slot:cell(info)="row">
            <div v-if="Number.isInteger(row.item.id)">
                <rkm-icon
                    :id="`pronto-atendimento-procedimento-info-${row.item.id}`"
                    class="mr-2"
                    icon="info-circle"
                />

                <rkm-popover
                    :target="`pronto-atendimento-procedimento-info-${row.item.id}`"
                    triggers="hover"
                >
                    <div>{{ row.item.centroCusto.setor.nome }}</div>
                    <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                    <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                </rkm-popover>
            </div>
        </template>

        <template v-slot:cell(ocupacao.codigo)="row">
            <span
                :title="row.item.ocupacao.nome"
                v-rkm-tooltip.hover
            >
                {{ row.item.ocupacao.codigo }}
            </span>
        </template>

        <template v-slot:cell(procedimento.codigo)="row">
            <span
                :title="row.item.procedimento.nome"
                v-rkm-tooltip.hover
            >
                {{ row.item.procedimento.codigo }}
            </span>
        </template>

        <template v-slot:cell(cid.codigo)="row">
            <span
                :title="row.item.cid.nome"
                v-rkm-tooltip.hover
            >
                {{ row.item.cid.codigo }}
            </span>
        </template>

        <template v-slot:cell(actions)="row">
            <rkm-button
                @click.stop="handleEdit(row.item)"
                color="primary"
                :disabled="row.item.disabled"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(row.item)"
                color="danger"
                :disabled="row.item.disabled"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {

            return {
                table: [
                    {
                        key: 'info',
                        label: '#',
                        class: 'col-min'
                    },
                    {
                        key: 'data',
                        label: 'Data',
                        sortable: true,
                    },
                    {
                        key: 'usuario.nome',
                        label: 'Profissional',
                        sortable: true,
                    },
                    {
                        key: 'ocupacao.codigo',
                        label: 'CBO',
                        sortable: true,
                    },
                    {
                        key: 'procedimento.codigo',
                        label: 'Procedimento',
                        sortable: true,
                    },
                    {
                        key: 'cid.codigo',
                        label: 'CID',
                        sortable: true,
                    },
                    {
                        key: 'quantidade',
                        label: 'Quantidade',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: 'Ações',
                        class: 'col-min'
                    },
                ],
            }
        },
    },
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                resolve(this.items.splice(this.items.findIndex(procedimento => procedimento.id === item.id), 1))
                this.$emit('atualizaKey')
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        handleEdit(item) {

            if (typeof this.edit === 'function') {

                this.edit(item)
            }
        }
    },
    props: {
        items: { type: Array, default: () => [] },
        edit: { type: Function },
    }
}
</script>